module.exports = __webpack_public_path__ + "images/anhui_banner01.jpg?ff4c892e92701249e360a8b4fe3b970b";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/anhui_banner01.jpg
// module id = 166
// module chunks = 1